<template>
<div class="chapter">
<div class="inner_page">
<p class="Dedication">To Mr. Hockey — as they say, he wasn’t in a class all by himself, but it didn’t take long to take attendance.<br/>—D.S.</p>
<p class="Acknowledgement">Special thanks to Baron Bedesky, Coordinator of Player Research and Relations, Professional Hockey Players’ Association.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?5c3a52bc